import type { FC } from 'react'
import React from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'
import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Getting started is easy`,
  description: `Whether your team is personalizing experiences in real time or building foundational data pipelines, Segment enables advanced use cases and customizations with low-code solutions.`,
}

const GettingStarted: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
        <Content>
          <Button
            size="medium"
            color="primary"
            variant="filled"
            tag="a"
            href={getAbsoluteUrl(`/demo/`, pageConfig)}
            onClick={() =>
              trackButtonClick({
                buttonText: `Get a CDP demo`,
                targetUrl: `/demo/`,
                buttonId: `pricing-landing-page-get-started-section-demo`,
              })
            }
          >
            Get a CDP demo
          </Button>
          <ButtonText
            iconEnd={ChevronRightIcon}
            href={getAbsoluteUrl(`/signup/`, pageConfig)}
            onClick={() =>
              trackButtonClick({
                buttonText: `Start with Connections for free`,
                targetUrl: `/pricing/connections/`,
                buttonId: `pricing-landing-page-get-started-section-connections`,
              })
            }
          >
            Start with Connections for free
          </ButtonText>
        </Content>
      </Copy>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-top: 40px;
  padding-bottom: 80px;
  max-width: 900px;
  margin: 0 auto;
`

const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 0 20px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  gap: 18px;
`

export default GettingStarted
